<template>
    <form-fieldset :error="error">
        <vue-select
            v-model="selected"
            :options="options"
            :reduce="option => option.value"
            :components="{ OpenIndicator }"
            :placeholder="placeholder"
            class="form-select"
            :class="fieldClass"
        />
    </form-fieldset>
</template>
<script>
// External dependencies.
import VueSelect from 'vue-select';
// Internal dependencies.
import FormFieldset from './FormFieldset';
import formField from '@/mixins/formField';

export default {
    components: {
        FormFieldset,
        VueSelect,
    },

    mixins: [
        formField,
    ],

    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        options: {
            required: true,
            type: Array,
        },
        placeholder: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        OpenIndicator: {
            render: createElement => createElement('span'),
        },
    }),

    computed: {
        selected: {
            /**
             * Gets value.
             *
             * @returns {string|number} Value.
             */
            get() {
                return this.value;
            },

            /**
             * Sets value.
             *
             * @param {string|number} value Value.
             */
            set(value) {
                this.$emit('change', value);
            },
        },
    },
};
</script>
